"use client";

import { useQuery } from "@tanstack/react-query";
import { browserCoreApi } from "@/lib/api";
import { albumKeys } from "./query-keys";

export function useAlbum(id: number | string) {
  return useQuery({
    queryKey: albumKeys.detail(id),
    queryFn: ({ signal }) => browserCoreApi.albums.detail(id, signal),
  });
}

export function useAlbumSongs(id: number | string) {
  return useQuery({
    queryKey: albumKeys.songs(id),
    queryFn: ({ signal }) => browserCoreApi.albums.songs(id, { limit: 200 }, signal),
  });
}
